import { render, staticRenderFns } from "./SearchUserDialog.vue?vue&type=template&id=4a23f4f2"
import script from "./SearchUserDialog.vue?vue&type=script&lang=js"
export * from "./SearchUserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports